"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOrganizationSelector = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line import/prefer-default-export
exports.StyledOrganizationSelector = (0, styled_components_1.default)(ui_components_1.DropdownSwitcher) `
  &&& {
    background-color: ${({ theme }) => theme.palette.common.white};
    border: 1px solid ${ui_components_1.baseColors.primaryGray200};
    width: unset;

    .MuiList-root {
      width: 100%;
    }

    .MuiListItemButton-root {
      justify-content: space-between;
      padding: ${({ theme }) => theme.spacing(1.5)} ${({ theme }) => theme.spacing(2)};
      gap: ${({ theme }) => theme.spacing(1)};

      &:hover {
        background: none;
      }

      .MuiTouchRipple-root {
        display: none;
      }
    }

    .MuiListItemText-root {
      flex: 1;
      min-width: 0;
      margin: 0;
    }

    .MuiListItemText-primary {
      display: none;
    }

    nav.menu-item--light-mode {
      border-bottom: none;

      &:hover {
        border-bottom: none;
      }

      svg {
        path {
          fill: ${({ theme }) => theme.palette.grey[400]};
        }
      }
    }
  }
`;
